import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "context" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", { id: "reg-login" }, "1.1 "),
  /*#__PURE__*/_createElementVNode("span", null, "注册"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createElementVNode("span", null, "登录")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "DEC"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("官网右上角"),
    /*#__PURE__*/_createElementVNode("a", { name: "_Toc24025" }, [
      /*#__PURE__*/_createElementVNode("span", null, "进行注册/登录。")
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc27584\"><span><span><span><b><span>注册</span></b></span></span></span></a><b><span>：</span></b><span>可通过手机号或邮箱方式进行注册。</span></p><p><a name=\"_Toc28762\"><span><span><span><b><span>登录</span></b></span></span></span></a><b><span>：</span></b></p><p><span> 您可通过注册时使用的邮件地址/手机号为账号，用以【账号+验证码】或【账号+密码】的方式进行登录服务。 </span></p><h2><a id=\"user-center\"><span><span><span><span><span>1.2 </span></span></span></span></span></a><span>个人中心</span></h2><p><span>登录后，可在网站右上角“头像”处进入。</span></p>", 5)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "user-center-1" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.2.1 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "个人信息")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "个人信息包含昵称（可修改）以及您注册时选择的方式【手机号或邮箱地址】和您专属的邀请码+和您已获得积分数量（可使用积分兑换奖励）。")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " 您可通过邀请好友/购买服务等操作来获取积分，积分可在积分商城内兑换体验时长/台月。 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "user-center-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.2.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "账户管理")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "展示您账户的余额以及您的订单、账户的台月和积分的流水。")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("span", null, "1.2.2.1")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "赠送服务")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "（1）验证身份", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "①　在区域1内输入您要赠予服务的账号，并点击“发送验证码”。", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "②　在区域2内输入您赠予服务账号绑定的邮箱/手机号所收到的验证码。", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "③　点击下一步进入身份验证。", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "（2）赠送服务", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "①　在区域1内输入您要赠送的台月数，并点击“发送验证码”。", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "②　在区域2内输入您账号绑定的邮箱/手机号所收到的验证码。", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "③　点击确定完成赠送服务", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", null, [
    /*#__PURE__*/_createElementVNode("span", null, "1.2.2.2")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "兑换奖励")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "1. 您可在“积分商城”内通过积分兑换台月数/体验时长等奖励。", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " 2. 您可通过邀请好友注册DEC账号或购买服务等操作来获取相应奖励积分，具体获取积分渠道和数额您可在积分商城右上角进行查看。 ", -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<p> 3. 专业版用户不可兑换体验时长，体验版用户不可兑换台月数，您可在您现有的服务到期后在兑换相应的奖励。 </p><h3><a id=\"user-center-3\"><span><span><span><span><span>1.2.3 </span></span></span></span></span><span>设置/修改密码</span></a></h3><p><span>根据您注册时选择的注册方式【手机号或邮箱地址】进行密码修改。</span></p><h2><a id=\"pay\"><span><span><span><span><span>1.3</span></span></span></span></span></a><span>购买服务</span></h2><h3><a id=\"pay-1\"><span>1.3.1</span></a><span>专业版服务</span></h3><p><a name=\"_Toc8297\"><span>（1）DEC官网－特权介绍，点击专业版购买服务</span></a><span>。</span></p>", 6)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）服务选择")
], -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc17241\"><span></span><span>区域1</span></a><span>展示购买不同台月的具体价格。</span></p><p><span>区域2</span><span>展示当前购买数量每台月的单价以及V码输入框。</span></p><p><span>区域</span>3<span>内可调整购买数量以及，当前购买数量所需金额</span></p><p><a name=\"_Toc1700\"><span></span><span>区域4 选择付款方式</span></a><span>。</span></p><p><a name=\"_Toc134\"><span>（</span>3</a><span>）微信或支付宝扫码支付</span></p><p><span>微信支付</span></p>", 6)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "支付宝支付")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（4）支付成功")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "您可以选择查看您的订单信息或下载DEC Hub直接使用服务。")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "pay-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.3.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "企业版服务")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）DEC官网－特权介绍，点击【联系我们】。")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）填写企业信息及商业用途等信息。")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（3）填写信息后点击确认，信息提交完毕后，平台工作人员会尽快与您联系。")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "download-dec" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "1.4 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "下载"),
  /*#__PURE__*/_createTextVNode("DEC Hub ")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("span", null, "下载方式：")
  ])
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "1、"),
  /*#__PURE__*/_createElementVNode("span", null, "可在官网顶部右上角下载DEC Hub；")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "2、"),
  /*#__PURE__*/_createElementVNode("span", null, "特权介绍－免费体验，点击免费体验下载DEC Hub；")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createElementVNode("span", null, "均需登录后才可下载。")
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'WebUseZh',
  setup(__props) {

const imageList = {
  image1: require("@/assets/document-images/c766b3fed5654234bfc71d8d1cede7ff.jpg"),
  image2: require("@/assets/document-images/54741bd04ff14b6b8351a9fe87decfc3.jpg"),
  image3: require("@/assets/document-images/acf6e169a1694012b0b30efc536598b7.jpg"),
  image4: require("@/assets/document-images/0221d3de0dd94605875c751e4a017818.jpg"),
  image5: require("@/assets/document-images/1cd838aac4ff4aa8be5150fdcf2be2a3.jpg"),
  image6: require("@/assets/document-images/2722ae5d94004613a1591ecdd3e6635c.jpg"),
  image7: require("@/assets/document-images/f84cce6e52b440b0896c38edba9041c0.jpg"),
  image8: require("@/assets/document-images/ac480f8147fd44b8bdf3ef256e527174.jpg"),
  image9: require("@/assets/document-images/1c722ebb36214ac9afef106f875b0b56.png"),
  image10: require("@/assets/document-images/6f199df701e24cf29bcba4cc18038578.jpg"),
  image11: require("@/assets/document-images/682cc569eff54bdb80d151faa385ba6d.jpg"),
  image12: require("@/assets/document-images/d98f5fdfb891405d87f83f41967ea80b.jpg"),
  image13: require("@/assets/document-images/gfit1.jpg"),
  image14: require("@/assets/document-images/gfit2.jpg"),
  image15: require("@/assets/document-images/zh-reward1.jpg"),
  image16: require("@/assets/document-images/zh-reward2.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image1,
          "preview-src-list": [imageList.image1],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_4,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image2,
          "preview-src-list": [imageList.image2],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3,
          "preview-src-list": [imageList.image3],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image4,
          "preview-src-list": [imageList.image4],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("p", null, [
      _createVNode(_component_el_image, {
        src: imageList.image13,
        "preview-src-list": [imageList.image13],
        fit: "contain"
      }, null, 8, ["src", "preview-src-list"])
    ]),
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _createElementVNode("p", null, [
      _createVNode(_component_el_image, {
        src: imageList.image14,
        "preview-src-list": [imageList.image14],
        fit: "contain"
      }, null, 8, ["src", "preview-src-list"])
    ]),
    _hoisted_19,
    _hoisted_20,
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _createElementVNode("p", null, [
      _createVNode(_component_el_image, {
        src: imageList.image15,
        "preview-src-list": [imageList.image15],
        fit: "contain"
      }, null, 8, ["src", "preview-src-list"])
    ]),
    _hoisted_24,
    _hoisted_25,
    _createElementVNode("p", null, [
      _createVNode(_component_el_image, {
        src: imageList.image16,
        "preview-src-list": [imageList.image16],
        fit: "contain"
      }, null, 8, ["src", "preview-src-list"])
    ]),
    _hoisted_26,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image5,
          "preview-src-list": [imageList.image5],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_32,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image6,
          "preview-src-list": [imageList.image6],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_33,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image7,
          "preview-src-list": [imageList.image7],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_39,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image8,
          "preview-src-list": [imageList.image8],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_40,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image9,
          "preview-src-list": [imageList.image9],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_41,
    _hoisted_42,
    _hoisted_43,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image10,
          "preview-src-list": [imageList.image10],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_44,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image11,
          "preview-src-list": [imageList.image11],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_45,
    _hoisted_46,
    _createElementVNode("p", null, [
      _createElementVNode("span", null, [
        _createVNode(_component_el_image, {
          src: imageList.image12,
          "preview-src-list": [imageList.image12],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ])
    ]),
    _hoisted_47,
    _hoisted_48,
    _hoisted_49,
    _hoisted_50
  ]))
}
}

})